import { numberInputAnatomy } from "@chakra-ui/react/anatomy";
import { defineSlotRecipe } from "@chakra-ui/react/styled-system";
import { interactiveTransition } from "./_shared";

export default defineSlotRecipe({
  slots: numberInputAnatomy.keys(),
  base: {
    // Root needs an explicit radius so `overflow: hidden` clips the
    // increment/decrement triggers to the rounded edge. Chakra base
    // doesn't set this, so we keep an override here — but use the
    // semantic l2 token so it rides the cascade.
    root: {
      borderRadius: "l2",
      overflow: "hidden",
      width: "100%",
      ...interactiveTransition,
    },
    incrementTrigger: {
      border: "none",
      pr: "0.25rem",
    },
    decrementTrigger: {
      border: "none",
      pr: "0.25rem",
    },
  },
  variants: {
    variant: {
      outline: {},
      solid: {
        control: { bg: "bg.muted" },
        root: { bg: "bg.muted" },
        input: { bg: "bg.muted" },
      },
    },
  },
  defaultVariants: {
    variant: "outline",
  },
});
